import axios from "axios";

const BASE_URL = "https://api.themoviedb.org/3";
const API_KEY = process.env.REACT_APP_TMDB_API_KEY;
const IMG_BASE = "https://image.tmdb.org/t/p";

// Image URL helpers
export const imgUrl = (path, size = "w500") => path ? `${IMG_BASE}/${size}${path}` : null;
export const backdropUrl = (path) => imgUrl(path, "w1280");
export const posterUrl = (path) => imgUrl(path, "w500");

// Reusable fetch wrapper
async function tmdbGet(endpoint, params = {}) {
  try {
    const response = await axios.get(`${BASE_URL}${endpoint}`, {
      params: { api_key: API_KEY, ...params },
    });
    return response.data;
  } catch (error) {
    console.error(`TMDB API Error [${endpoint}]:`, error.message);
    return null;
  }
}

// ─── Trending ──────────────────────────────
export const getTrending = (type = "all", timeWindow = "week") =>
  tmdbGet(`/trending/${type}/${timeWindow}`);

// ─── Movies ────────────────────────────────
export const getPopularMovies = () => tmdbGet("/movie/popular");
export const getNowPlaying = () => tmdbGet("/movie/now_playing");
export const getTopRatedMovies = () => tmdbGet("/movie/top_rated");

// ─── TV ────────────────────────────────────
export const getPopularTV = () => tmdbGet("/tv/popular");
export const getOnTheAir = () => tmdbGet("/tv/on_the_air");
export const getTopRatedTV = () => tmdbGet("/tv/top_rated");

// ─── Discover (with filters) ───────────────
export const discoverMovies = (params = {}) => tmdbGet("/discover/movie", { sort_by: "popularity.desc", ...params });
export const discoverTV = (params = {}) => tmdbGet("/discover/tv", { sort_by: "popularity.desc", ...params });

// ─── Details ───────────────────────────────
export const getDetails = (type, id) => tmdbGet(`/${type}/${id}`);
export const getCredits = (type, id) => tmdbGet(`/${type}/${id}/credits`);
export const getVideos = (type, id) => tmdbGet(`/${type}/${id}/videos`);

// ─── Search ────────────────────────────────
export const searchMulti = (query) => tmdbGet("/search/multi", { query });

// ─── Genre IDs (commonly used) ─────────────
export const GENRES = {
  ACTION: 28,
  COMEDY: 35,
  DRAMA: 18,
  HORROR: 27,
  THRILLER: 53,
  MYSTERY: 9648,
  ROMANCE: 10749,
  SCIFI: 878,
  ANIMATION: 16,
};

// Helper to extract YouTube trailer key from videos response
export function getTrailerKey(videosData) {
  if (!videosData?.results) return null;
  const trailer = videosData.results.find(
    (v) => v.type === "Trailer" && v.site === "YouTube"
  ) || videosData.results.find(
    (v) => v.site === "YouTube"
  );
  return trailer?.key || null;
}

// Helper to get genre names from genre_ids + a genre map
export function getMediaType(item) {
  if (item.media_type) return item.media_type;
  if (item.title) return "movie";
  if (item.name) return "tv";
  return "movie";
}

export function getTitle(item) {
  return item.title || item.name || "Unknown";
}

export function getReleaseYear(item) {
  const date = item.release_date || item.first_air_date;
  return date ? date.substring(0, 4) : "";
}
